import React from 'react';
import { Box, Typography } from '@mui/material';
import * as styles from './styles';

function Copyrights() {
    const year = new Date().getFullYear();

    return (
        <Box sx={styles.copyrightBar}>
            <Typography sx={styles.copyrightText}>
                © {year} ECAL. The official calendar marketing platform of the world's best brands.
            </Typography>
            <Typography sx={styles.copyrightText}>
                ecal.world · ecalworld.com · my.ecal.com
            </Typography>
        </Box>
    );
}

export default Copyrights;
